
import { PasswordStrength } from "./password-strength.enum";
export class PasswordTest {
   containsDigit: boolean;
   containsLower: boolean;
   containsUpper: boolean;
   containsEightChars: boolean;
   containsSpecial: boolean;
   strength: PasswordStrength; 
   clearedValidations: number;
   moreThanEighteenChar: boolean;
}